import React from 'react'

export function HighlightedEmployerName({ employerName }: { employerName: string }) {
  return <span className="bg-cobranding-hover px-1">{employerName}</span>
}
